import React from 'react';
import { IValidation } from 'src/services/formValidator';
import BarionStatement from '../../statements/BarionStatement/BarionStatement';
import PrivacyStatement from '../../statements/PrivacyStatement/PrivacyStatement';
import TermsConditionsStatement from '../../statements/TermsConditionsStatement/TermsConditionsStatement';

interface IStatementSectionPropsBase {
    validation: IValidation;
}

export interface IPrivacyStatementProps extends IStatementSectionPropsBase {
    setDataPolicy: (value: boolean) => void;
}

export interface ITermsCondidtionsProps extends IStatementSectionPropsBase {
    setTermsAccepted: (value: boolean) => void;
}

export interface IStatementSectionProps extends IPrivacyStatementProps {
    setTermsAccepted: (value: boolean) => void;
}

const StatementSection: React.FC<IStatementSectionProps> = ({ validation, setDataPolicy, setTermsAccepted }) => {

    return (
        <section>
            <PrivacyStatement validation={validation} setDataPolicy={setDataPolicy} />
            <TermsConditionsStatement validation={validation} setTermsAccepted={setTermsAccepted} />
            <BarionStatement />
        </section>
    );
}

export default StatementSection;